import { THost } from '@/entities/room'
import { CertifiedBadge, Profile } from '@/entities/user'

export const UserInformation = ({
  picProfile,
  name,
  isCertificated,
  introduction,
}: THost) => {
  return (
    <div>
      <Profile
        src={picProfile}
        alt={`${name} 호스트의 프로필 이미지`}
        size={60}
        className="mb-3"
      />

      <div className="mb-1.5 flex items-center gap-2.5">
        <span className="typo-body1 font-semibold text-gray-900">{name}</span>
        {isCertificated && <CertifiedBadge />}
      </div>

      <p className="typo-label1 min-h-[66px] w-60 font-normal whitespace-break-spaces text-gray-600">
        {introduction}
      </p>
    </div>
  )
}
